module.exports = __webpack_public_path__ + "media/images/spree/frontend/panels/product/newmarket-9a91f406584863b0ce634754fb1d8db6.jpg";